import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import Theme from '../../theme';

const Friend = ({
    t,
    status,
}) => {
    return (
       <View style={styles.container}>
           <Text style={styles.text}>{t(status).toUpperCase()}</Text>
       </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderTopWidth: 1,
        borderTopColor: '#C7C7C7',
        borderBottomWidth: 1,
        borderBottomColor: '#C7C7C7',
        borderLeftWidth: 1,
        borderLeftColor: '#C7C7C7',
        borderRightWidth: 1,
        borderRightColor: '#C7C7C7',
        borderRadius: 3,
        marginLeft: 5,
    },
    text: {
        color: Theme.CHARCOAL,
        fontSize: 11,
        fontFamily: Theme.Custom700,
        paddingHorizontal: 1,
        letterSpacing: 0.4,
    }
});

export default Friend;
